// extracted by mini-css-extract-plugin
module.exports = {"reactionsSummary":"EventReactions_reactionsSummary__3vuya","reactionsWrapper":"EventReactions_reactionsWrapper__2Lia2"};